import { React } from 'react';
import {
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  ButtonToolbar,
  Button,
  Col,
  FlexboxGrid,
  Schema,
} from 'rsuite';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Link } from 'utils/with-i18next';
import PhoneInput from 'react-phone-input-2';

import PasswordInput from 'components/PasswordInput';
import Styles from './styles.js';

const StyledSection = styled('section')`
  font-size: 21px;
  font-weight: 400;
  margin-bottom: 10px;
  line-height:45px;
`;

function FormComponent({
  signup,
  login,
  setPassword,
  forgotPassword,
  titleText,
  buttonText,
  belowButtonText,
  belowButtonLink,
  handleSubmit,
  isLoading,
  onChangeFormValue,
  formValue,
  isPopup,
  setformAction,
}) {
  let formRef = null;
  signup || setPassword;
  const getModelDefinition = () => {
    if (login) {
      return Schema.Model({
        email: Schema.Types.StringType()
          .isEmail('Please enter the correct email')
          .isRequired('This field is required'),
        password: Schema.Types.StringType()
          .isRequired('This field is required')
          .minLength(8, 'Min 8 characters'),
      });
    } else if (signup) {
      return Schema.Model({
        email: Schema.Types.StringType()
          .isEmail('Please enter the correct email')
          .isRequired('This field is required'),
        password: Schema.Types.StringType()
          .isRequired('This field is required')
          .minLength(8, 'Min 8 characters'),
        firstName: Schema.Types.StringType().isRequired('This field is required'),
        lastName: Schema.Types.StringType().isRequired('This field is required'),
        phone: Schema.Types.StringType().isRequired('This field is required'),
        confirm_password: Schema.Types.StringType()
          .isRequired('This field is required')
          .addRule((value, data) => {
            if (value !== data.password) {
              return false;
            }
            return true;
          }, 'The passwords are inconsistent twice'),
      });
    } else if (setPassword) {
      return Schema.Model({
        password: Schema.Types.StringType()
          .isRequired('This field is required')
          .minLength(8, 'Min 8 characters'),
        confirm_password: Schema.Types.StringType()
          .isRequired('This field is required')
          .addRule((value, data) => {
            if (value !== data.password) {
              return false;
            }
            return true;
          }, 'The passwords are inconsistent twice'),
      });
    } else if (forgotPassword) {
      return Schema.Model({
        email: Schema.Types.StringType()
          .isEmail('Please enter the correct email')
          .isRequired('This field is required'),
      });
    }
  };
  // // Used to set the form action that is for popup model
  // const setFormActionHandler = (e, tempFormAction) => {

  //   console.log('Form acion: ' + tempFormAction)
  //   setformAction(tempFormAction);
  // }

  const onClickSubmit = event => {
    event.preventDefault();

    if (!formRef.check()) {
      // alert('error');
      return;
    }
    handleSubmit(event);
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      onClickSubmit(event);
    }
  };

  return (
    <>
      <Form
        fluid
        ref={ref => (formRef = ref)}
        formValue={formValue}
        model={getModelDefinition()}
        checkTrigger={'blur'}
        onChange={onChangeFormValue}>
        {/* hide welcome text when isPopup = true */}
        {!isPopup && <StyledSection>{titleText}</StyledSection>}
        {(signup || login || forgotPassword) && (
          <FormGroup>
            <ControlLabel className="leading-8">Email</ControlLabel>
            <FormControl
              name="email"
              size="sm"
              className="email round-border"
              type="email"
              placeholder={'john.doe@gmail.com'}
              onKeyPress={handleKeyPress}
            />
          </FormGroup>
        )}
        {login && (
          <FormGroup>
            <ControlLabel className="leading-8">Password</ControlLabel>
            <PasswordInput onKeyPress={handleKeyPress} name="password" size="sm" className="password round-border " />
            <FlexboxGrid justify="center">
              <FlexboxGrid.Item>
                <Link href="/forgot-password" passHref>
                  {/* If isPopup is true then showing the fogetPassword component else the /forgot-password is shown */}
                  <a
                    onClick={
                      isPopup
                        ? e => {
                            e.preventDefault();
                            setformAction('forgot-password');
                          }
                        : null
                    }>
                    <HelpBlock className='leading-7'>Forgot password?</HelpBlock>
                  </a>
                </Link>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </FormGroup>
        )}
        {signup && (
          <FormGroup>
                <ControlLabel className='leading-8'>First Name</ControlLabel>
                <FormControl name="firstName" size="sm" className="round-border" placeholder={'John'} />
                <ControlLabel className='leading-8'>Last Name</ControlLabel>
                <FormControl name="lastName" size="sm" className="round-border" placeholder={'Doe'} />
          </FormGroup>
        )}
        {signup && (
          <FormGroup className='for-phone-ri8'>
            <ControlLabel className='leading-8 '>Phone Number</ControlLabel>
            <FormControl
              size="xs"
              className=""
              name="phone"
              country={'ca'}
              inputProps={{
                name: 'phone',
                className: 'rs-input rs-input-sm phone round-border',
              }}
              // disableDropdown
              accepter={PhoneInput}
            />
          </FormGroup>
        )}
        {(signup || setPassword) && (
          <FormGroup>
                <ControlLabel className='leading-8'>Password</ControlLabel>
                <PasswordInput name="password" size="sm" className="password round-border" />
                <ControlLabel className='leading-8'> Confirm Password</ControlLabel>
                <PasswordInput name="confirm_password" size="sm" className="password round-border" />
          </FormGroup>
        )}
        <FormGroup>
          <ButtonToolbar style={{ marginTop: '20px' }}>
            <Button
              size="sm"
              onClick={onClickSubmit}
              className="round-border submit-button login-btn-bg"
              block
              loading={isLoading}
              appearance="primary">
              {buttonText}
            </Button>
          </ButtonToolbar>
          <FlexboxGrid justify="center">
            <FlexboxGrid.Item>
              <Link href={belowButtonLink} passHref>
                {/* If the popup flag is true then show all functionality in popup box */}
                <a
                  onClick={
                    isPopup
                      ? e => {
                          e.preventDefault();
                          //  The popup box is rendered based on belowButtonLink props passed LoginFrom/SignupForm components
                          belowButtonLink === '/login' ? setformAction('login') : setformAction('signup');
                        }
                      : null
                  }>
                  <HelpBlock className='leading-7'>{belowButtonText}</HelpBlock>
                </a>
              </Link>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </FormGroup>
        {(signup || login) && (
          <FormGroup className="social-login">
            <FlexboxGrid justify="space-between">
              {/* <Link prefetch={false} href="/auth/facebook" passHref>
                <Button className="round-border social-button" color="blue" appearance="ghost">
                  <FlexboxGrid.Item>Facebook</FlexboxGrid.Item>
                </Button>
              </Link> */}
              {/* When isPopup= true then show facebook login  */}
              {/* {isPopup && (
                <Button
                  style={{ width: width <= '750' ? '-webkit-fill-available' : '26%', marginBottom: '10px' }}
                  href="/auth/facebook"
                  className="round-border social-button"
                  color="blue"
                  appearance="ghost">
                  <FlexboxGrid.Item>Facebook</FlexboxGrid.Item>
                </Button>
              )} */}

              {/* {isPopup && (
                <>
                  <Button
                    style={{
                      width: '45%',
                      marginBottom: '10px',
                    }}
                    href={'/auth/linkedin'}
                    className="round-border social-button"
                    color={'cyan'}
                    appearance="ghost">
                    <FlexboxGrid.Item>LinkedIn</FlexboxGrid.Item>
                  </Button>
                  <Button
                    style={{
                      width: '45%',
                      marginBottom: '10px',
                    }}
                    href={'/auth/gmail'}
                    className="round-border social-button"
                    color={'red'}
                    appearance="ghost">
                    <FlexboxGrid.Item>Gmail</FlexboxGrid.Item>
                  </Button>
                </>
              )} */}
            </FlexboxGrid>
          </FormGroup>
        )}
      </Form>
      <Styles/>
    </>
  );
}

FormComponent.prototypes = {
  login: PropTypes.bool,
  signup: PropTypes.bool,
  setPassword: PropTypes.bool,
  forgotPassword: PropTypes.bool,
  buttonText: PropTypes.string,
};

export default FormComponent;
